// Do not modify this file by hand!
// Re-generate this file by running lit-localize
import { str } from '@lit/localize';
/* eslint-disable no-irregular-whitespace */
/* eslint-disable @typescript-eslint/no-explicit-any */
export const templates = {
    's05d2bf045ed4dcd6': `Mis pruebas`,
    's09a45db408570a7a': `Mi perfil`,
    's17b9dbb305701a26': `Cologuard y Riskguard son marcas registradas de Exact Sciences Corporation. Todas las demás marcas comerciales son propiedad de sus respectivos propietarios.`,
    's3736464cf8d6fa08': `Asistencia`,
    's435965374707319b': `Ofrecer comentarios`,
    's452d8770394b89ef': `Menú de opciones de usuario`,
    's49e763aed00877a8': `Principal`,
    's542b6804ac0ecf3f': `Póngase en contacto con el servicio de atención al cliente 24 horas al día, 7 días a la semana.`,
    's622421be65bb31bc': `Facturación`,
    's7fee95b66225e1fb': `Panel de control`,
    'sa4100eab71dc7768': `Aviso de la HIPAA`,
    'sa64925faa6fc6919': `Seleccionar idioma`,
    'saeca1d734cdc30ff': `Hola: `,
    'sb64127e4e4f0b575': `Cerrar sesión`,
    'sbffe2c7598324d8e': `Menú de navegación`,
    'sc9ad6d3b6e7b4c5e': `Iniciar un chat ahora`,
    'scae799b026a32126': `Condiciones de uso`,
    'se9a9b0c892dedcea': `Acerca de nosotros`,
    'sef4999e4b768721f': `Política de privacidad`,
    'sf483b4b0451c0570': str `© ${0} Exact Sciences Corporation. Todos los derechos reservados.`,
};
